import React from 'react';
import { Spin } from 'antd';
import cn from 'classnames';
import styles from './Loading.module.scss';

const Loading = ({ className, ...props }) => {
  return (
    <div className={cn(styles.root, className)}>
      <Spin {...props} />
    </div>
  );
};

export default Loading;
